import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { SwitchFilters } from './filters';
import { SwitchList } from './list';
import { SwitchFilter } from '../../../../shared/types/modules/switch';

export const Switch = () => {
    const [filters, setFilters] = useState<SwitchFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de conmutador">
                <SwitchFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <SwitchList filters={filters} />
        </>
    );
};
